import { useQuery } from "@tanstack/solid-query";
import { type Component, Show, Suspense } from "solid-js";
import {
	MobilePricingFeaturesTableEntityV4,
	PricingFeaturesTableEntityV4
} from "~/solidJs/entities/PricingFeaturesTableEntity/PricingFeaturesTableEntityV2";
import { ProductsApi } from "~/solidJs/shared/api/ProductsApi";

export const AllFeaturesTable: Component = () => {
	const tariffs = useQuery(() => ProductsApi.getNewProductListOptions());
	const features = useQuery(() => ProductsApi.getPricingTableDataGroupedOptions());

	return (
		<div class="flex w-full flex-col items-center justify-center gap-3 md:gap-10">
			<h2
				class="md:header-48-semibold py-1 font-semibold text-4xl text-black"
				id="all_features"
			>
				All Features
			</h2>
			<Suspense>
				<Show when={tariffs.data && features.data}>
					{/* Desktop version */}
					<div class="custom-tw-hidden w-full md:flex">
						<PricingFeaturesTableEntityV4
							selectedPriceId="plus"
							tariffsRes={tariffs.data!}
							tariffsResFeatures={features.data!}
						/>
					</div>

					{/* Mobile version */}
					<div class="md:custom-tw-hidden w-full">
						<MobilePricingFeaturesTableEntityV4
							selectedPriceId="plus"
							tariffsRes={tariffs.data!}
							tariffsResFeatures={features.data!}
						/>
					</div>
				</Show>
			</Suspense>
		</div>
	);
};
